import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';

export const LiquidationRecord = z.object({
  processedDate: zodDateOrString,
  soldPrice: z.number(),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type LiquidationRecord = z.infer<typeof LiquidationRecord>;

export const LiquidationRecordInput = LiquidationRecord.pick({
  processedDate: true,
  soldPrice: true,
});
export type LiquidationRecordInput = z.infer<typeof LiquidationRecordInput>;
